angular.module("ainapp")
    .controller("approvalConfigController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Approval Config";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Users = [];
            MainService.GetEmployeeUsers().then(function (response) {
                $scope.Users = response.data;
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.Init = function () {


                $scope.ViewVal = 0;
                $scope.ViewValType = 'Material Request';

                $scope.CostSetting = {
                    VoucherType: "Material Request",
                    Order: 0,
                    LabelName: "",
                    FileName: "",
                    BranchId: "",
                }

                $scope.CostCenterSettings = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetVoucherApprovalConfig("Material Request").then(function (response) {
                    $scope.CostCenterSettings = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();


            $scope.switchTab = function (tab, type) {
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.CostCenterSettings = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.GetVoucherApprovalConfig(type).then(function (response) {
                    $scope.CostCenterSettings = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })
                $scope.refreshCostCenter();

            }

            $scope.refreshCostCenter = function () {

                $scope.CostSetting = {
                    VoucherName: $scope.ViewValType,
                    Order: 0,
                    IsFinal: false,
                    UserId: "",
                }

            }

            $scope.editCostCenter = function (data) {

                $scope.CostSetting = data;

            }

            $scope.saveCostSettings = function () {

                if ($scope.CostSetting.CostCenterId == "") {
                    toastr.warnig("Choose Cost Center");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.CostSetting.VoucherName = $scope.ViewValType;
                    MainService.AddVoucherApprovalConfig($scope.CostSetting).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                            $scope.refreshCostCenter();
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                        $scope.load = false;
                    })
                }

            }

            $scope.deleteCostCenter = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteVoucherApprovalConfig(data.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                        $scope.refreshCostCenter();
                    } else {
                        toastr.error("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                })

            }





      }]);
